import styles from './AlarmBar.module.css';

const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.max(0, s) % 60).padStart(2, '0')}`;

/**
 * Top alarm banner. On the monitor it is CLICKABLE (when `onSilenceToggle` is
 * provided) to pause the alarm AUDIO for a couple of minutes — the visual alarm
 * stays up, matching a real monitor's alarm-silence button.
 */
export default function AlarmBar({ alarms, silenced = false, remainingSec = 0, onSilenceToggle }) {
  const hasAlarms = alarms && alarms.length > 0;
  const level = hasAlarms ? alarms[0].level : null;
  const clickable = typeof onSilenceToggle === 'function';

  const className = [
    styles.alarmBar,
    hasAlarms ? styles[level] : styles.noAlarms,
    clickable ? styles.clickable : '',
  ].join(' ');

  return (
    <div
      className={className}
      onClick={onSilenceToggle}
      role={clickable ? 'button' : 'status'}
      aria-live="polite"
      tabIndex={clickable ? 0 : undefined}
      title={clickable
        ? (silenced ? 'Alarm audio paused — click to resume' : 'Click to silence alarm audio (2 min)')
        : undefined}
    >
      {hasAlarms ? (
        <div className={styles.content}>
          {alarms.map((alarm, i) => (
            <div key={i} className={styles.alarmItem}>
              <span className={styles.vitalName}>{alarm.vitalName}</span>
              <span className={styles.value}>
                {alarm.value} {alarm.unit}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.message}>{silenced ? 'Alarm Audio Paused' : 'No Alarms'}</div>
      )}

      {clickable && (
        <span className={`${styles.silenceBtn} ${silenced ? styles.silenceBtnOn : ''}`}>
          {silenced ? `🔕 ${fmt(remainingSec)}` : '🔔'}
        </span>
      )}
    </div>
  );
}
